var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.127,
    height: 18.506,
    viewBox: "0 0 26.127 18.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_116-youtube",
    "data-name": "116-youtube",
    d: "M25.549,6.144l.033.213a3.312,3.312,0,0,0-2.251-2.3l-.023-.005C21.27,3.5,13.074,3.5,13.074,3.5S4.9,3.489,2.841,4.053A3.314,3.314,0,0,0,.574,6.335l-.005.023A36.417,36.417,0,0,0,.6,19.363l-.034-.216a3.312,3.312,0,0,0,2.251,2.3l.023.005c2.035.554,10.233.554,10.233.554s8.174,0,10.233-.554a3.313,3.313,0,0,0,2.269-2.282l.005-.023A34.035,34.035,0,0,0,26.127,13c0-.079,0-.16,0-.241s0-.162,0-.25a35.114,35.114,0,0,0-.578-6.364ZM10.459,16.728V8.788l6.821,3.976Z",
    transform: "translate(0 -3.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4b4ab8c22e63606ae8f12b239a71a73e.svg";
export { ForwardRef as ReactComponent };